import { ReactElement } from 'react';

import { Option } from '../../types';
import { StyledBoldText } from './styled';

export const highlightSearch = (text: string, searchQuery: string): ReactElement | string => {
  if (searchQuery.length === 0) {
    return text;
  }
  const regex = new RegExp(`(${searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) =>
        regex.test(part) ? (
          <StyledBoldText data-testid="bold-text" key={`${text}-${index}`}>
            {part}
          </StyledBoldText>
        ) : (
          <span key={`${text}-${index}`}>{part}</span>
        )
      )}
    </>
  );
};

export const isElementInArray = (el: Option, array: Option[]): boolean => {
  return array.map(({ value }) => value).indexOf(el.value) > -1;
};

export const getSelectionsText = (selectedItems: Option[], loading?: boolean): string => {
  if (selectedItems.length === 0) {
    return 'Select';
  }
  if (selectedItems.length === 1) {
    return loading ? 'Loading...' : selectedItems[0].label;
  }

  return `${selectedItems.length} Selected`;
};
